import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { OrderKeys } from '../OrderKeys';
import { OptionsDictionary } from './SortOptionDefinitions';
import { viewSortOptions } from './ViewSortOptions';

export const recentsSpaceDefaultSortOrder: IOrderClause[] = [Order.desc(OrderKeys.lastAccessedAt)];

export const recentViewsOptions: OptionsDictionary = {
    ...viewSortOptions,
    'lastAccessedAt': {
      id: 'lastAccessedAt',
      getMenuItemDisplayValue: Messages.sortLastAccessedAt,
      subSortOptions: {
        'desc': {
          id: 'lastAccessedAt.desc',
          field: OrderKeys.lastAccessedAt,
          getMenuItemDisplayValue: Messages.sortByNewest,
          getButtonDisplayValue: Messages.sortLastAccessedAtNewest,
          ascending: false,
          toOrderClauseArray: () => [Order.desc(OrderKeys.lastAccessedAt)]
        },
        'asc': {
          id: 'lastAccessedAt.asc',
          field: OrderKeys.lastAccessedAt,
          getMenuItemDisplayValue: Messages.sortByOldest,
          getButtonDisplayValue: Messages.sortLastAccessedAtOldest,
          ascending: true,
          toOrderClauseArray: () => [Order.asc(OrderKeys.lastAccessedAt)]
        }
      }
    }
};
